import React from "react";
import { useMediaQuery, useTheme } from '@mui/material';
import ParkITLogo from '../../assets/parkIT.svg?react';

import position from '../../styles/position';
import AnimateFrom from '../../components/animations/AnimateFrom';
import { LoginPageV2 } from './LoginPageV2';
import styles from './styles';
import VersionInfo from './VersionInfo';


const LoginPage = () => {
    const theme = useTheme();
    const isLargeDevice = useMediaQuery(theme.breakpoints.up('md'));

    return <>
        <AnimateFrom style={{ opacity: 0, zoom: 0 }}>
            <div style={isLargeDevice ? { ...position.fixedFill, ...styles.background } : { ...styles.background, ...styles.backgroundSmall }}></div>
            <div style={isLargeDevice ? { ...position.absoluteFill, } : {}}>
                <div style={isLargeDevice == true ? styles.sideBarWrapper : styles.sideBarWrapperSmall}>
                    <div style={isLargeDevice == true ? styles.sideBar : styles.sideBarSmall}>
                        <LoginPageV2 />
                    </div>
                </div >
                {/* spacer div to prevent issue with footer covering login button */}
                <div style={{ height: 88 }}></div>
                <div style={styles.footer}>
                    <div style={isLargeDevice ? styles.webFooter : styles.tabletFooter}>
                        <ParkITLogo style={{ transform: "scale(0.5)", marginLeft: -12, paddingTop: 20 }} />
                    </div>
                </div>
            </div>
        </AnimateFrom>

        <div style={{ position: "fixed", right: 5, bottom: 5, color: "black", opacity: 0.5 }}>
            <VersionInfo />
        </div>
    </>
};

export default LoginPage;
